import { z } from "zod";

import { nullableTextField } from "./nullable-text-field";

const codeField = nullableTextField();
const descriptionField = nullableTextField();

export const create = z.object({
  name: z.string().min(1, "Required"),
  description: descriptionField.create,
  code: codeField.create,
  price: z.coerce.number().finite("Required"),
  billingMode: z.enum(["PER_SAMPLE", "PER_ACCESSION"]),
  enabled: z.boolean().prefault(false),
});

export const update = create
  .omit({ code: true })
  .extend({ code: codeField.update, id: z.number() });
